import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reports-stat-cards" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "reports-stat-cards__body" }
const _hoisted_4 = { class: "reports-stat-cards__label" }
const _hoisted_5 = {
  key: 1,
  class: "reports-stat-cards__value"
}
const _hoisted_6 = {
  class: "reports-stat-cards__icon-wrap",
  "aria-hidden": "true"
}

import Skeleton from 'primevue/skeleton';
import type { ReportStatItem } from '@/composables/useReportsPayments';

interface Props {
    items: ReportStatItem[]
    activeId?: string | null
    loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ReportsStatCards',
  props: {
    items: {},
    activeId: { default: null },
    loading: { type: Boolean, default: false }
  },
  emits: ["update:activeId"],
  setup(__props: any, { emit: __emit }) {

/* eslint-env vue/setup-compiler-macros */
const props = __props;

const emit = __emit;

const toggle = (id: string) => {
    emit('update:activeId', props.activeId === id ? null : id);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
      return (_openBlock(), _createElementBlock("button", {
        key: item.id,
        type: "button",
        class: _normalizeClass(["reports-stat-cards__card", { 'reports-stat-cards__card--active': __props.activeId === item.id }]),
        onClick: ($event: any) => (toggle(item.id))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, _toDisplayString(item.label), 1),
          (__props.loading)
            ? (_openBlock(), _createBlock(_unref(Skeleton), {
                key: 0,
                width: "55%",
                height: "39px",
                "border-radius": "6px"
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(item.value), 1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("i", {
            class: _normalizeClass([item.icon, "reports-stat-cards__icon"])
          }, null, 2)
        ])
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})